module.exports = __webpack_public_path__ + "img/vertical_6_2_8019.274af3cf.png";